import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../AbstractElements';
import NewsTable from './NewsTable';
const News = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle='News' parent='News'  />
      <Container fluid={true}>
        <Row>
          <NewsTable />
        </Row>
      </Container>
    </Fragment>
  );
};

export default News;
